module.exports = __webpack_public_path__ + "media/packs/landing_page/images/studios/mahat-4341f8e9932d503e8d6e6ff1569c613e.png";